import tippy from "tippy.js";

// To add a tooltip add the `tippy-content` data property
//
// <button data-tippy-content="Tooltip">Text</button>

function initializeTooltips(root) {
  // Tippy: plain text
  tippy(
    root.querySelectorAll(
      "[data-tippy-content]:not([data-tippy-html-content])",
    ),
  );

  // Tippy: HTML content
  tippy(
    root.querySelectorAll("[data-tippy-content][data-tippy-html-content]"),
    {
      allowHTML: true,
    },
  );

  // Bootstrap tooltips
  Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]')).forEach(
    (el) => new (window.bootstrap?.Tooltip || window.Tooltip)(el),
  );

  // Tippy: template-based
  Array.from(root.querySelectorAll("[data-tippy-template]")).forEach((el) => {
    tippy(el, {
      content(ref) {
        const id = ref.getAttribute("data-tippy-template");
        // prefer scoped template, fallback to document
        const tpl = root.querySelector(id) || document.querySelector(id);
        return tpl ? tpl.innerHTML : "";
      },
      allowHTML: true,
      interactive: el.hasAttribute("data-tippy-interactive"),
    });
  });
}

$(document).on("turbo:load turbo:frame-render", function () {
  initializeTooltips(document);
});

/**
 * Re-initialize tooltips after Turbo Stream updates.
 * Overrides the render function so we can run code after DOM mutation.
 * Skips "remove" actions. Uses the stream target id to find the updated node.
 */
document.addEventListener("turbo:before-stream-render", (event) => {
  const origRender = event.detail.render;

  event.detail.render = function (streamEl) {
    const action = streamEl.getAttribute("action");
    if (action === "remove") return;
    const id = streamEl.getAttribute("target");
    origRender(streamEl);
    initializeTooltips(document.getElementById(id) || document);
  };
});
